import AbstractWatchableBrickConfig from './abstract-watchable-brick-config';

export default class AdBrickConfig extends AbstractWatchableBrickConfig {
  constructor(params) {
    super(params);

    this.posterUrl = params.posterUrl || params.poster_url;
    this.videoUrl = params.videoUrl || params.video_url;
    this.mode = params.mode;
    this.version = params.version;
    this.color = params.color;
    this.buildWithIframe = true;
  }

  errors() {
    const errorArr = super.errors();
    const VALID_MODES = ['home-video', 'theatrical', 'tv-tune-in'];

    if (!this.mode) {
      errorArr.push('mode cannot be null');
    } else if (VALID_MODES.indexOf(this.mode) === -1) {
      errorArr.push(`mode can only be one of the following: ${VALID_MODES.join(', ')}`);
    }

    return errorArr;
  }

  toQueryParamObject() {
    const queryParams = super.toQueryParamObject();

    if (this.posterUrl) queryParams.posterUrl = this.posterUrl;
    if (this.videoUrl) queryParams.videoUrl = this.videoUrl;
    if (this.mode) queryParams.mode = this.mode;
    if (this.color) queryParams.color = this.color;
    if (this.version) queryParams.version = this.version;

    return queryParams;
  }
}



// WEBPACK FOOTER //
// ./src/models/ad-brick-config.js